export default __webpack_public_path__ + "static/media/Courier.cea6bfdd.svg";